import { formatHeading } from './utils';

/**
 * Filter out the RAW TERMS section from the markdown.
 * That section is for internal use by marketing_strategist_agent, not for the user.
 */
function filterInternalSections(markdown: string): string {
  return markdown.replace(/(-{3}\s*)?## RAW TERMS \(for content optimization\)[\s\S]*$/, '').trim();
}

/**
 * Format SEO Content Analysis data for copying as Markdown
 */
export const formatSEOContentCopy = (data: any): string => {
  if (!data || (!data.response_text && !data.query && !data.query_url)) {
    return 'No SEO content analysis available';
  }

  const sections: string[] = [];

  // Header
  sections.push(formatHeading('SEO Content Analysis', 1));
  sections.push('');

  // Scored state — content evaluation result
  if (data.status === 'scored' && data.content_score != null) {
    sections.push(formatHeading('Content Score', 1));
    sections.push('');
    sections.push(`**Your Score:** ${data.content_score}`);
    if (data.target_score != null) {
      sections.push(`**Target (competitor median):** ${data.target_score}`);
      sections.push(
        data.passed
          ? '**Result:** Above target — your content is competitive.'
          : '**Result:** Below target — improvements recommended.',
      );
    }
    sections.push('');
    if (data.passed === false && data.response_text) {
      const optionsText = data.response_text
        .replace(/^# Content Score:.*\n?/, '')
        .replace(/\*\*Target.*\n?/, '')
        .replace(/\*\*Result.*\n?/, '')
        .trim();
      if (optionsText) {
        sections.push(optionsText);
        sections.push('');
      }
    }
    return sections.join('\n');
  }

  // Ready state — full analysis
  if (data.status === 'ready' && data.response_text) {
    sections.push(filterInternalSections(data.response_text));
    sections.push('');
    if (data.query) {
      sections.push(`**Query ID:** \`${data.query}\``);
      sections.push('');
    }
    return sections.join('\n');
  }

  // Processing state
  if (data.status === 'waiting' || data.status === 'in progress') {
    sections.push(
      'Your SEO content analysis is being processed. This typically takes about 90 seconds. Please check back in a moment.',
    );
    sections.push('');
    if (data.query) {
      sections.push(`**Query ID:** \`${data.query}\``);
      sections.push('');
    }
    return sections.join('\n');
  }

  // Created state — brief just submitted
  if (data.response_text) {
    sections.push(data.response_text);
    sections.push('');
  }

  if (data.query) {
    sections.push(`**Query ID:** \`${data.query}\``);
    sections.push('');
  }

  return sections.join('\n');
};
